import { render, staticRenderFns } from "./PrebidPartner.vue?vue&type=template&id=155ae559&"
import script from "./PrebidPartner.vue?vue&type=script&lang=js&"
export * from "./PrebidPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports